import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config/config";
import { isTokenExpired } from "./adminSlice";

const rawToken = localStorage.getItem("brandToken");
let token = null;
let brandInfo = null;

if (rawToken && !isTokenExpired(rawToken)) {
  token = rawToken;
  try {
    const stored = localStorage.getItem("brandInfo");
    if (stored) {
      brandInfo = JSON.parse(stored);
    }
  } catch (e) {
    brandInfo = null;
  }
} else if (rawToken) {
  localStorage.removeItem("brandToken");
  localStorage.removeItem("brandInfo");
}

export const brandLogin = createAsyncThunk(
  "brandAuth/login",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${config.backendUrl}/brand-auth/signin`, {
        email,
        password,
      });
      localStorage.setItem("brandToken", response.data.token);
      localStorage.setItem("brandInfo", JSON.stringify(response.data.brand));
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Sign in failed");
    }
  }
);

const initialState = {
  token,
  brandInfo,
  loading: false,
  error: null,
};

const brandAuthSlice = createSlice({
  name: "brandAuth",
  initialState,
  reducers: {
    setBrandSession: (state, action) => {
      state.token = action.payload.token;
      state.brandInfo = action.payload.brand;
      state.loading = false;
      state.error = null;
      localStorage.setItem("brandToken", action.payload.token);
      localStorage.setItem("brandInfo", JSON.stringify(action.payload.brand));
    },
    brandLogout: (state) => {
      state.token = null;
      state.brandInfo = null;
      state.loading = false;
      state.error = null;
      localStorage.removeItem("brandToken");
      localStorage.removeItem("brandInfo");
    },
    clearBrandError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(brandLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(brandLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.token;
        state.brandInfo = action.payload.brand;
      })
      .addCase(brandLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setBrandSession, brandLogout, clearBrandError } = brandAuthSlice.actions;
export default brandAuthSlice.reducer;
